<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont" v-if="!isExpired && !loading">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: auto; text-align: center;display: flex;"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="margin: 10px auto; text-align: center">
                        Queue Service Request Form
                      </h3>
                      <p style="margin: 10px auto 50px; text-align: center">
                        Submit your information for obtaining the Queue Service
                        on Personal Content Removal.
                      </p>
                    </div>

                    <form class="wpcf7-form" @submit.prevent="submit">
                      <div class="form-group">
                        <label for="exampleInputEmail1">First Name*</label>
                        <input
                          v-model="firstName"
                          type="text"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          placeholder="Enter First Name"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Last Name*</label>
                        <input
                          v-model="lastName"
                          type="text"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          placeholder="Enter Last Name"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Email address*</label>
                        <input
                          v-model="email"
                          type="email"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Enter email"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Mobile Number*</label>
                        <div
                          style="
                            flex: 1 1 0%;
                            flex-direction: row;
                            justify-content: space-between;
                            display: flex;
                            border: 1px solid #c8cccf;
                            border-radius: 10px;
                          "
                        >
                          <vue-country-code
                            @onSelect="onSelect"
                            :preferredCountries="['us', 'gb']"
                            style="border: 0"
                          >
                          </vue-country-code>
                          <input
                            v-model="mobileNumber"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter mobile number"
                            required=""
                            type="number"
                            style="max-width: 90%; border: 0"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Address Line*</label>
                        <input
                          type="text"
                          v-model="addressLine1"
                          class="form-control"
                          id="exampleInputAddressLine1"
                          placeholder="Enter Address"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >State / Province</label
                        >
                        <input
                          v-model="state"
                          type="text"
                          class="form-control"
                          id="exampleInputState"
                          placeholder="Enter State / Province"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Postal / Zip Code</label
                        >
                        <input
                          v-model="zipCode"
                          type="text"
                          class="form-control"
                          id="exampleInputPostal"
                          placeholder="Enter Postal / Zip Code"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">City</label>
                        <input
                          type="text"
                          v-model="city"
                          class="form-control"
                          id="exampleInputCity"
                          placeholder="Enter City"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Country</label>
                        <div
                          style="
                            flex: 1 1 0%;
                            flex-direction: row;
                            justify-content: space-between;
                            display: flex;
                            border: 1px solid #c8cccf;
                            border-radius: 10px;
                          "
                        >
                          <vue-country-code
                            @onSelect="onSelectCountry"
                            :preferredCountries="['us', 'gb']"
                            style="border: 0"
                          >
                          </vue-country-code>
                          <input
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter Country"
                            required=""
                            type="text"
                            readonly
                            style="max-width: 90%; border: 0"
                            v-model="country"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Package Type*</label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="packageSelection"
                            name="packageSelection"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="general">
                              General Service Package
                            </option>
                            <option value="custom">
                              Customized Service Package
                            </option>
                          </select></span
                        >
                      </div>
                      <div class="error" v-if="allFieldsRequiredError">
                        <p
                          style="font-size: 14px; color: red; font-weight: bold; text-align: center; margin-bottom: 10px;"
                        >
                          Please fill all details!
                        </p>
                      </div>
                      <div class="error" v-if="emailFormatError">
                        <p
                          style="font-size: 14px; color: red; font-weight: bold; text-align: center; margin-bottom: 10px;"
                        >
                          Invalid email address.
                        </p>
                      </div>
                      <button
                        type="button"
                        class="btn btn-primary check-btn"
                        v-on:click="goNext"
                        style="display: block;margin: 0 auto;"
                      >
                        Next
                      </button>
                    </form>
                  </div>
                </div>
                <div class="row tick-cont" v-if="isExpired && !loading">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="margin: 10px auto; text-align: center;">
                        Token Expired or Invalid
                      </h3>
                      <p style="margin: 10px auto 50px; text-align: center;">
                        Your provided token number is either invalid or expired. Please contact Clear Me Out Service.
                      </p>
                      <button type="button" v-on:click="submit" class="btn btn-primary check-btn" style="margin: 0px auto;display: block;border-radius: 10px;background: #6874dd;margin-top: 35px;">
                          Back Home
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";

export default {
  name: "support_track",
  data() {
    return {
      msg: "Clear Me Out - Support",
      packageSelection: "general",
      firstName: "",
      lastName: "",
      email: "",
      mobileNumber: "",
      mobileNumberCode: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      zipCode: "",
      city: "",
      allFieldsRequiredError: false,
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      allTermsRequiredError: false,
      emailError: false,
      dateOfBirth: new Date(),
      country: "United States",
      refId: null,
      loading: true,
      isExpired: false,
      emailFormatError: false,
      agree1: false,
      agree2: false,
      agree3: false,
      agree4: false,
      agree5: false,
      agree6: false,
      agree7: false,
      agree8: false,
    };
  },
  components: {
    datetime: Datetime,
  },
  methods: {
    onSelect: function (d) {
      this.mobileNumberCode = d.dialCode;
    },
    goNext: function (d) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.allFieldsRequiredError = false;
      this.emailFormatError = false;

      if (
        this.packageSelection == "" ||
        this.firstName == "" ||
        this.lastName == "" ||
        this.country == "" ||
        this.email == "" ||
        this.mobileNumber == "" ||
        this.addressLine1 == "" ||
        this.state == "" ||
        this.zipCode == ""
      ) {
        this.allFieldsRequiredError = true;
        return;
      }
      
      if (!re.test(String(this.email).toLowerCase())) {
        this.emailFormatError = true;
        return;
      }

      this.$store.commit({
        type: "selectedPackage",
        form_refId: this.refId,
        form_packageSelection: this.packageSelection,
        form_firstName: this.firstName,
        form_lastName: this.lastName,
        form_country: this.country,
        form_email: this.email,
        form_mobileNumber: this.mobileNumberCode + "" + this.mobileNumber,
        form_city: this.city,
        form_addressLine1: this.addressLine1,
        form_addressLine2: this.addressLine2,
        form_state: this.state,
        form_zipCode: this.zipCode,
      });
      this.$router.push(`/${this.refId}/select-package`);
    },
    onAddClientInputLegalDocs: function (d) {
      if (this.clientInputLegalDocs.length > this.clientInputLegalDocsLimit) {
        return;
      }
      this.clientInputLegalDocs.push({ file: "" });
    },
    onAddClientInputSignature: function (d) {
      if (this.clientInputSignature.length > this.clientInputSignatureLimit) {
        return;
      }
      this.clientInputSignature.push({ file: "" });
    },
    onChangeClientInputLegalDocs: function (item, index) {
      if (
        item &&
        item.target &&
        item.target.files &&
        Array.isArray(item.target.files)
      ) {
        this.clientInputLegalDocs[index].file = item.target.files[0];
      } else {
        this.clientInputLegalDocs[index].file = null;
      }
    },
    onChangeClientInputSignatureDocs: function (item, index) {
      if (
        item &&
        item.target &&
        item.target.files &&
        Array.isArray(item.target.files)
      ) {
        this.clientInputSignature[index].file = item.target.files[0];
      } else {
        this.clientInputSignature[index].file = null;
      }
    },
    onSelectCountry: function (d) {
      this.country = d.name;
    },
    submit: function (e) {
      window.location.href = "https://www.clearmeout.com";
    },
  },
  mounted() {
    this.refId = ((this.$router.currentRoute || {}).params || {}).refId;

    const $this = this;

    $.post("https://stagingapi.clearmeout.com/api/auth/login", {
      email: "user@test.com",
      password: "123456",
    }).done(function (data) {
      if (data.data && data.data.authorization) {
        $.ajax({
          url:
            "https://stagingapi.clearmeout.com/api/user/verifyReferenceId/" +
            $this.refId,
          data: {},
          type: "GET",
          beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", data.data.authorization);
            xhr.setRequestHeader("Content-Type", "application/json");
          },
          success: function (data) {
            if(data.data && Object.keys(data.data).indexOf("expired") > -1) {
              $this.isExpired = data.data.expired;
            } else {
              $this.isExpired = true
            }

            $this.loading = false;
          },
        });
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue